import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';

@Component({
  selector: 'app-rfp-chatbot-implementation',
  templateUrl: './rfp-chatbot-implementation.component.html',
  styleUrls: ['./rfp-chatbot-implementation.component.css']
})
export class RfpChatbotImplementationComponent {
  isBrowser:boolean=false;


  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/a-deep-dive-into-rfp-chatbot-implementation-and-results/"
  },
  "headline": "A Deep Dive into RFP Chatbot Implementation and Results",
  "description": "Managing Requests for Proposals (RFPs) is a complex and time-consuming challenge. It necessitates a deep dive into detailed requirements, careful analysis, and substantial time investment in drafting compelling responses.",
  "image": "https://mitresource.com/assets/images/blogs/rfpchatbot.webp",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-05-30"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
if(this.isBrowser){     
  AOS.init({disable: 'mobile'});
}
  }


  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  
  constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}

  baseUrl = Constants.baseUrl;



  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('A Deep Dive into RFP Chatbot Implementation and Results');

    this.metaService.addTags([
      { name: 'description', content: "In the world of manufacturing, where everything hinges on how smoothly you can manage your supply chain, get products out the door, and keep your customers happy, being ahead of the curve isn\'t just nice—it's essential." },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'A Deep Dive into RFP Chatbot Implementation and Results' },
      { property: 'og:url', content: 'https://mitresource.com/a-deep-dive-into-rfp-chatbot-implementation-and-results/' },
      { property: 'og:image', content: 'https://mitresource.com/wp-content/themes/magantiWeb/assets/images/blogs/rfpchatbot.webp' },
      { property: "og:description", content: "Managing Requests for Proposals (RFPs) is a complex and time-consuming challenge." },
    ]);
    

  }
}
  

